export const plans1 = [
	{
		title: 'PLAN STANDARD',
		descrition: 'El flujo de producción completo.',
		price: '$799 USD',
		priceBefore: '$989 USD',
		urls: {
			ninguno: 'https://checkout.bold.co/payment/LNK_MENCPBOCM8',
			internacional:
				'https://libel.academy/pago-paypal/payment.html?YW1vdW50PTI5OSZpZD1MaWJlbCBIVUIgUGxhbiBDb3JlIC0gQWNjZXNvIDEgYfFv',
		},
		temario: 'https://drive.google.com/file/d/1_ydjtZ3CJ-6nBCndavf-agaUwd7BU-n-/view?usp=sharing',
		items: [
			{
				title: 'Feedback en vivo.',
			},
			{
				title: 'Duración 5 meses.',
			},
			{
				title: 'Grabación de clases.',
			},
			{
				title: 'Acceso un año.',
			},
		],
		center: true,
		top: false,
		ball: true,
		promo: '30% DTO',
		type: 'presencial',
	},
	{
		title: 'PLAN GROW',
		descrition: 'El flujo de producción completo.',
		price: '$989 USD',
		priceBefore: '$1.229 USD',
		urls: {
			ninguno: 'https://checkout.bold.co/payment/LNK_3D1JOOBGGL',
			internacional:
				'https://libel.academy/pago-paypal/payment.html?YW1vdW50PTM5OSZpZD1MaWJlbCBIVUIgUGxhbiBGb3JnZSAtIEFjY2VzbyAxIGHxbw==',
		},
		temario: 'https://drive.google.com/file/d/1_ydjtZ3CJ-6nBCndavf-agaUwd7BU-n-/view?usp=sharing',
		items: [
			{
				title: 'Feedback en vivo.',
			},
			{
				title: 'Duración 6 meses.',
			},
			{
				title: 'Grabación de clases.',
			},
			{
				title: 'Acceso un año.',
			},
		],
		center: true,
		top: true,
		ball: false,
		promo: '30% DTO',
		type: 'presencial',
	},
];
